<template>
  <ReportNotificationsModal
    v-model="notifications"
    :report-name="report && report.name"
    :from-route="true"
    :show-report-notifications-modal="true"
    :partner-population-ids="report && report.partner_population_ids"
    @notifications-modal-hidden="hideNotificationsModal"
    @input="reportsStore.refreshReportsStore"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import ReportNotificationsModal from '@/components/reports/ReportNotificationsModal.vue';

import { BASE_ROUTES } from '@/constants/routes';
import { useReportsStore } from '@/stores';
import { ReportNotification } from '@/types/reports';

const route = useRoute();
const folderId = computed(() => route.params.folder_id);

const reportsStore = useReportsStore();
const { reports } = storeToRefs(reportsStore);
const reportId = computed(() => route.query.id);
const report = computed(() =>
  reports.value.find((report) => report.id === reportId.value),
);

const notifications = computed<ReportNotification[]>(
  () => (report.value?.notification_configs as ReportNotification[]) || [],
);

const router = useRouter();
const routeName = computed(() => {
  if (route.name?.toString().includes('partner_details')) {
    return 'partner_details';
  } else if (route.name?.toString().includes('lists')) {
    return 'lists';
  }
  if (!folderId.value) {
    return 'reports';
  }
  return BASE_ROUTES.REPORT_FOLDER;
});
async function hideNotificationsModal() {
  if (routeName.value === 'partner_details') {
    await router.push({
      name: routeName.value,
      params: { partner_org_id: route.params.partner_org_id },
    });
  } else if (!folderId.value) {
    await router.push({ name: routeName.value });
  } else {
    await router.push({
      name: BASE_ROUTES.REPORT_FOLDER,
      params: { folder_id: folderId.value },
    });
  }
}
</script>
